import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async'; 
import { injectMetaPixelIfProduction } from './utils/metaPixels';

const root = ReactDOM.createRoot(document.getElementById('root'));


injectMetaPixelIfProduction();
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
